(() => {
  const elementName = "dm-vehicle-parts-finder";
  if (customElements.get(elementName)) return;

  class DMVehiclePartsFinder extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this.controller) this.initialize();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    initialize() {
      const form = this.querySelector("[data-finder-form]");
      const modelSelect = this.querySelector("[data-vehicle-selector]");
      const categorySelect = this.querySelector("[data-category-selector]");
      const clearButton = this.querySelector("[data-clear-button]");
      const status = this.querySelector("[data-finder-status]");
      const dataElement = this.querySelector("[data-finder-data]");
      if (!form || !modelSelect || !categorySelect || !clearButton || !status || !dataElement) return;

      let data;
      let baseUrl;
      try {
        data = JSON.parse(dataElement.textContent);
        baseUrl = new URL(data.baseUrl, window.location.origin);
        if (baseUrl.origin !== window.location.origin || !Array.isArray(data.vehicles)) return;
      } catch {
        return;
      }

      const isHandle = (value) => typeof value === "string" && /^[a-z0-9][a-z0-9-]*$/.test(value);
      const vehicles = data.vehicles.filter((vehicle) =>
        vehicle && typeof vehicle.id === "string" && typeof vehicle.label === "string" &&
        isHandle(vehicle.handle) && Array.isArray(vehicle.categories)
      );
      if (!vehicles.length) return;

      const appendOption = (select, label, value) => {
        const option = document.createElement("option");
        option.textContent = label;
        option.value = value;
        select.append(option);
      };
      modelSelect.replaceChildren();
      appendOption(modelSelect, data.modelPlaceholder || "Select your Tank", "");
      vehicles.forEach((vehicle) => appendOption(modelSelect, vehicle.label, vehicle.id));

      const selectedVehicle = () => vehicles.find((vehicle) => vehicle.id === modelSelect.value);
      const categoriesFor = (vehicle) => {
        const handles = new Set();
        return (vehicle?.categories || []).filter((category) => {
          if (!category || typeof category.label !== "string" || !isHandle(category.handle) || handles.has(category.handle)) return false;
          handles.add(category.handle);
          return true;
        });
      };
      const updateCategories = () => {
        const vehicle = selectedVehicle();
        const categories = categoriesFor(vehicle);
        categorySelect.replaceChildren();
        appendOption(categorySelect, data.categoryPlaceholder || "All categories", "");
        categories.forEach((category) => appendOption(categorySelect, category.label, category.handle));
        categorySelect.disabled = !vehicle || !categories.length;
        status.textContent = vehicle && !categories.length ? (data.noCategoriesText || "") : "";
      };
      updateCategories();

      this.controller = new AbortController();
      const listenerOptions = { signal: this.controller.signal };
      modelSelect.addEventListener("change", updateCategories, listenerOptions);
      clearButton.addEventListener("click", () => {
        form.reset();
        updateCategories();
        modelSelect.focus();
      }, listenerOptions);
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        const vehicle = selectedVehicle();
        if (!vehicle) {
          modelSelect.reportValidity();
          return;
        }
        const handles = [vehicle.handle];
        const category = categoriesFor(vehicle).find((item) => item.handle === categorySelect.value);
        if (category) handles.push(category.handle);
        const destination = new URL(baseUrl.href);
        destination.pathname = destination.pathname.replace(/\/+$/, "") + "/" + handles.join("+");
        destination.search = "";
        destination.hash = "";
        window.location.assign(destination.href);
      }, listenerOptions);

      form.hidden = false;
      this.dataset.ready = "true";
    }
  }

  customElements.define(elementName, DMVehiclePartsFinder);
})();
